import { createSelector } from '@reduxjs/toolkit'
import { selectMe } from 'selectors/auth'

interface SearchUser {
  id: string
  username?: string
  [key: string]: unknown
}

interface UsersSearchState {
  results: SearchUser[]
  isFetching: boolean
}

interface UsersSearchRootState {
  users?: {
    search?: UsersSearchState
  }
}

interface MeValue {
  id: string | null
}

interface SelectMeResult {
  me: MeValue
}

const defaultUsersSearchState: UsersSearchState = {
  results: [],
  isFetching: false,
}

const selectUsersSearch = (state: Record<string, unknown>): UsersSearchState => {
  const usersState = state as UsersSearchRootState
  return usersState.users?.search || defaultUsersSearchState
}

export default createSelector(selectUsersSearch, selectMe, (usersSearch, { me }: SelectMeResult) => {
  const { results, isFetching } = usersSearch
  return {
    isFetching,
    results: results.filter((user) => {
      return user.id !== me.id
    })
  }
})
